import { createFileRoute } from '@tanstack/react-router'
import { LoginEntryPage } from '@/features/auth'

/** `/login` — SSO + email entry. */
export const Route = createFileRoute('/login/')({
  component: LoginEntryPage,
})
